<template>
  <v-container>
    <h4>Cleaning supply list</h4>
    <v-row
        v-for="(item, i) in cleaning_supply_list"
        :key="i"
      >
        <v-col
          cols="1"
        >
          {{ i+1 }}
        </v-col>
        <v-col
          cols="9"
        >
          {{ item.name }}
          <br/>
          <small>Price: {{ item.price }}</small>
        </v-col>
        <v-col
          cols="2"
        >
          <v-checkbox
            v-model="item.selected"
            :value="item.selected"
            label="Select"
          />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: 'CleaningSupplyList',
  components: { },
  props: ['cleaning_supply_list', 'cleaning_supplies'],
  data: () => ({ }),
  async mounted () {
    await this.getCleaningSupplyList();
  },
  methods: {
    async getCleaningSupplyList () {
      try {
        const { data } = await this.$http.get('/back-office/cleaning-supplies', authHeader())
        for (let cleaning_supply of data) {
          this.cleaning_supply_list.push({
            id: cleaning_supply.id,
            name: cleaning_supply.name,
            price: cleaning_supply.price,
            selected: false
          });
        }
        if (this.cleaning_supplies && this.cleaning_supplies.length) {
          for (let cleaning_supply of this.cleaning_supply_list) {
            let element = this.cleaning_supplies.find(element => element.id == cleaning_supply.id)
            if (element) {
              cleaning_supply.selected = true
            }
          }
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
  }
}
</script>